/**
 * Trigger: tr_expenses_insert
 * Purpose: Update account balances and daily balances when an expense is inserted
 * Table: expenses
 * Event: AFTER INSERT
 */
export const TR_EXPENSES_INSERT = `
CREATE TRIGGER tr_expenses_insert
AFTER INSERT ON expenses
FOR EACH ROW
BEGIN
  UPDATE account_balances
  SET expenses_amount = expenses_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id;

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_id, new.expense_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_id, new.expense_date);

  UPDATE account_daily_balances
  SET expenses_amount = expenses_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id
    AND balance_date = new.expense_date;

  INSERT OR IGNORE INTO exchange_rates (rate_date, rate, currency_id)
  SELECT new.expense_date, new.exchange_rate, new.currency_id
  WHERE new.exchange_rate > 0;
END;
`;
